<template lang="pug">
.container.solicitarPermuta
  .card
    cadastro-sicarf-retificacao(v-if="cadastroJson" titleCadastro="Retificação de Cadastro", routeName="retificacao", :cadastroJson="cadastroJson" :cadastroEmpty="empty", :tabs="tabs")
</template>

<script>
import CadastroSicarfRetificacao from '@/screens/central/components/CadastroSicarfRetificacao'
import empty from '@/screens/central/cadastros/para/empty/emptyNaoOneroso'
import { mapActions } from 'vuex'
export default {

  components: {
    CadastroSicarfRetificacao
  },

  data () {
    return {
      // O atributo @name deve ser o mesmo da rota definida no router
      tabs: [
        {
          label: 'Cadastrante',
          name: 'receptor/retificacao/cadastrante',
          codigo: 'CADASTRANTE'
        },
        {
          label: 'Interessado',
          name: 'receptor/retificacao/interessado',
          codigo: 'INTERESSADO'
        },
        {
          label: 'Imóvel',
          name: 'receptor/retificacao/imovel',
          codigo: 'IMOVEL'
        },
        {
          label: 'Destinação e Uso do Imóvel',
          name: 'receptor/retificacao/destinacaoUsoImovel',
          codigo: 'DESTINACAO_USO_IMOVEL'
        },
        {
          label: 'Georreferenciamento',
          name: 'receptor/retificacao/georreferenciamento'
        },
        {
          label: 'Resumo',
          name: 'receptor/retificacao/resumo',
          isResumo: true
        }
      ],
      empty: empty,
      cadastroJson: null
    }
  },

  async created () {
    this.cadastroJson = await this.findCadastro(this.$route.params.id)
  },

  methods: {
    ...mapActions({
      findCadastro: 'cadastro/findCadastroById'
    })
  }

}
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  .card {
    width: 100%;
  }
}

@media (max-width: 780px) {
  .solicitarPermuta {
    position: relative;
    top: 60px;
    right: 60%;
    width: 360px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/receptor/retificacao/Cadastro.vue